define("command-palette/utils/get-command-lookup", ["exports"], function (_exports) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.getCommandLookup = getCommandLookup;
  0; //eaimeta@70e063a35619d71feaimeta@70e063a35619d71f
  function getCommandLookup(Command) {
    return `command:${Command.commandId}`;
  }
});